/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CompanyStatusRepresentation {
    Unknown = 'unknown',
    Active = 'active',
    Disabled = 'disabled',
    Creating = 'creating',
    Expired = 'expired',
    Phantom = 'phantom',
    MarkedForRemove = 'markedForRemove',
    SiteResourceFailedOnCreating = 'siteResourceFailedOnCreating',
    CreatingSiteResource = 'creatingSiteResource',
    UpdatingSiteResource = 'updatingSiteResource',
    SiteResourceFailedOnUpdating = 'siteResourceFailedOnUpdating'
};

